var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCelery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_371_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7951 0H2.20487C1.6201 0 1.05929 0.232299 0.645792 0.645792C0.232299 1.05929 0 1.6201 0 2.20487V15.7951C0 16.3799 0.232299 16.9407 0.645792 17.3542C1.05929 17.7677 1.6201 18 2.20487 18H15.7951C16.3799 18 16.9407 17.7677 17.3542 17.3542C17.7677 16.9407 18 16.3799 18 15.7951V2.20487C18 1.6201 17.7677 1.05929 17.3542 0.645792C16.9407 0.232299 16.3799 0 15.7951 0ZM9.11687 13.3565C10.2991 13.2386 11.4574 13.0007 12.5499 12.529C12.9997 12.335 13.2136 12.4466 13.3774 12.8703C13.5162 13.2081 13.6722 13.5387 13.8449 13.8605C13.9722 14.1089 13.9492 14.2727 13.6685 14.3958C11.8602 15.193 9.96626 15.6428 7.99617 15.553C5.92487 15.4581 4.80939 14.2393 4.752 12.1544C4.72174 11.0431 4.74678 9.92974 4.74678 8.48244C4.79478 7.51513 4.63513 6.20765 4.82087 4.91061C5.0567 3.26504 6.13774 2.24452 7.79478 2.15166C9.71225 2.03148 11.6306 2.37285 13.3889 3.14713C14.0317 3.43096 14.0296 3.44661 13.7353 4.06017C13.6372 4.26365 13.5381 4.46609 13.44 4.66957C13.1061 5.35722 13.1082 5.35096 12.4122 5.08696C11.2988 4.66957 10.1541 4.37322 8.9687 4.33461C7.73113 4.29391 7.24696 4.78122 7.24487 5.99791C7.24487 7.89287 7.24487 9.78748 7.24487 11.6817C7.23861 12.9297 7.86157 13.4849 9.1127 13.3586L9.11687 13.3565Z",
    fill: "#007987"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_371_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelery);
export default __webpack_public_path__ + "static/media/Celery.4d2126042e75376dfc7dd14f1f491c17.svg";
export { ForwardRef as ReactComponent };